
(function() {
    'use strict';

    /**
     * Category grid and product component
     * @type ItxCatalogCmp
     * @name ProductCategoryGridCmp
     */
    var ItxCatalogCmp = {
        controller: ItxCatalogCmpCtrl,
        templateUrl: 'ItxCatalogCmp.html'
    };
    
    angular.module('itxApp.catalog').component('itxCatalog', ItxCatalogCmp);

    ItxCatalogCmpCtrl.$inject = ['$scope',
        '$rootScope',
        '$timeout',
        'ItxCategorySvc',
        'ItxProductSwiperSvc',
        'ItxUtilsFct',
        'Product',
        'Category',
        'ItxLoaderFct',
        'ProductViewedCacheSvc',
        'ItxConfigurationSvc',
        'logger',
        'SeoService',
        'CatalogUrlService',
        'ItxHeraclesSvc',
        'imDispatcherService',
        'ItxScreenSizeSvc',
        'CmsConfigSvc',
        'CommonServices',
        'DUTTI_CONS',
        'ItxConstants',
        'imProductService'
    ];

    function ItxCatalogCmpCtrl($scope,
        $rootScope,
        $timeout,
        ItxCategorySvc,
        ItxProductSwiperSvc,
        ItxUtilsFct,
        Product,
        Category,
        ItxLoaderFct,
        ProductViewedCacheSvc,
        ItxConfigurationSvc,
        logger,
        SeoService,
        CatalogUrlService,
        ItxHeraclesSvc,
        imDispatcherService,
        ItxScreenSizeSvc,
        CmsConfigSvc,
        CommonServices,
        DUTTI_CONS,
        ItxConstants,
        imProductService
    ) {

        //VARIABLES VALIDADAS
        var _this = this;
        _this.isCategoryPage = false;
        _this.isHeraclesEnable = false;
        _this.realCategory = null;

        _this.categoryScroll = 0;
        _this.firstEntry = ''; 
        _this.isMobile = false;
        _this.reloadCategory = false;

        _this.$onInit = function() {
            //_this.loaderFct.hide();
            CatalogUrlService.init();
            inditex.onReady(function() {
                _this.isMobile = ItxScreenSizeSvc.isMobile();   
                // check whether this is a product page or category page
                if (inditex.iProductId) {
                    _this.firstEntry = 'product';
                   var colorId = _this.getProductColorFromNavigation(inditex.iProductId);
                   var product = ProductViewedCacheSvc.getProduct(inditex.iProductId);
                   var set = null;
                   if(product && product.set){
                    set = product.set;
                   }
                   if(product && product.categoryId){
                    _this.firstEntry = 'category';
                    inditex.iCategoryId = product.categoryId;
                   }
                    return _this.loadProduct(inditex.iProductId, colorId, true, set);
                } else if (inditex.iCategoryId) {
                  CmsConfigSvc.getProperty('enable_heracles').then(function(data) {
                    if(data) {
                      _this.isHeraclesEnable = true;
                    }
                    _this.firstEntry = 'catalog';
                    _this.isCategoryPage = true;
                    return _this.loadCategory(inditex.iCategoryId, true);
                  }).catch(function(){
                    _this.firstEntry = 'catalog';
                    _this.isCategoryPage = true;
                    return _this.loadCategory(inditex.iCategoryId, true);
                  }); 
                }
            });

            //Destroy the initial SEO
            $('.copy-container').html('');
        };

        _this.getProductColorFromNavigation = function(productId){
            var colorId;
            if(ItxConfigurationSvc.isSeoUrlsEnabled()){
                var product = ProductViewedCacheSvc.getProduct(productId);
                if(product){
                    colorId = product.colorId;
                }
            }
            else{
                var urlParams = inditex.decodeUrl(document.location).params;
                if (urlParams.colorId) {
                    colorId = urlParams.colorId;
                }
            }
            return colorId;
        };
        _this.onNavigateToProduct = function(product) {
            
            _this.setProductIndex(product);

            if (_this.category) {
                _this.categoryScroll = $(window).scrollTop();
            }
            
            _this.isCategoryPage = false;

            // el objecto selectedColor no siempre existe
            var id = null;
            if(product.state.selectedColor && product.state.selectedColor.id){
                id = product.state.selectedColor.id;
            }

            ProductViewedCacheSvc.addProduct(product.id, id,_this.category.id, product.activeDetail.xmediaDefaultSet );
            
            if (ItxProductSwiperSvc.isCompatibleBrowser()) {
                if (product.state) {
                    ItxUtilsFct.scrollTopProduct();
                    CatalogUrlService.changeStateProduct(product);
                }
            } else {
                window.location.href = product.getUrl();
            }
        };

        _this.onNavigateToCategory = function(category) {
            _this.productIndex = null;
            category = ItxCategorySvc.getCategory(category.id);
            CatalogUrlService.changeStateCategory(category);
        };      

        _this.showProductNavigation = function() {
            var isPrevDutti = document.referrer.indexOf(document.location.host) > -1; //Indica si la página previa es MassimoDutti

            if (_this.firstEntry === 'product') {
                if (isPrevDutti) {
                    return true;
                } else {
                    if (_this.categoryPageLoadedOnce) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return true;
            }
        };

        $rootScope.$on('categoryCtrl:updateCategory', function(evt, category) {
            category = ItxCategorySvc.getCategory(category.id);
            CatalogUrlService.changeStateCategory(category);
            if(_this.isMobile) {
              $rootScope.$emit('subcategoryCarousel:onLoad', category);
            }
        });

        $rootScope.$on('categoryCtrl:loadCategory', function(evt, category) {
            _this.isCategoryPage = true;
            _this.loadCategory(category.id);
        });

        $rootScope.$on('categoryCtrl:loadProduct', function(evt, productId, colorId, set) {
            _this.isCategoryPage = false;
            _this.loadProduct(productId, colorId, set);
        });
       
        _this.loadCategory = function(categoryId, initialLoad) {
            //ITX LEGACY
            inditex.iPage = 'ItxCategoryPage';
            $('html').attr('id', 'ItxCategoryPage');
            inditex.iCategoryId = categoryId;

            let sessionHeracles = undefined;
            let categoryHeracles = { heraclesId: 0, categoryId: 0 };
            const cookieGroup = DUTTI_CONS.COOKIE_GROUPS.FUNCTIONAL_PERSONALIZATION;
            const isCookieGroupAllowed = CommonServices.isCookieGroupAllowed(cookieGroup);
            if(isCookieGroupAllowed){
                const heraclesKey = `heracles_${categoryId}`;
                sessionHeracles = inditex.getSessionStorage(heraclesKey);
            }
			
			if(sessionHeracles && _this.isHeraclesEnable) {
				var heracles = JSON.parse(sessionHeracles);
				if(heracles && heracles.heraclesId) {
					categoryHeracles.heraclesId = heracles.heraclesId;
					categoryHeracles.categoryId = heracles.categoryId;
				}
			}
			_this.categoryPageLoadedOnce = true;
			if ((_this.category && parseInt(categoryId) === _this.category.id) 
				|| _this.category &&  _this.category.id === parseInt(categoryHeracles.heraclesId)) {
                _this.isCategoryPage = true;

                var intervalScroll = setInterval(function () {
                    if(!$('itx-product-page').is(':visible') && $('category-page').is(':visible') ) {
                        $(window).scrollTop(_this.categoryScroll);
                        window.clearInterval(intervalScroll); 
                    } 
                }, 100);
               
                inditex.iCategoryId = categoryId;
                SeoService.updateMetas();
                //Es la misma categoría

                ItxLoaderFct.hide();
                if(initialLoad){
                    CatalogUrlService.initialStateCategory(_this.category);
                }
                return;
            }
            
            var category = ItxCategorySvc.getCategory(categoryId);

            inditex.iCategoryId = categoryId;
            // En el pase entre parrillas volvemos arriba
            $(window).scrollTop(0);

            _this.category = null;  
            
            if(_this.isHeraclesEnable){ 
                categoryHeracles = ItxHeraclesSvc.verifyAttachmentCategory(category);
            }    
            
            if(_this.isHeraclesEnable && categoryHeracles) {
                new Category({id: categoryHeracles}).fetch().then(function(categoryHeraclesFetched) {
                    _this.realCategory = category;   
                    _this.category = categoryHeraclesFetched;
                    _this.setDataCategoryFetched(initialLoad, category);                
                }).Catch(function() {
                    category.fetch().then(function() {    
                        _this.category = category;
                        _this.realCategory = null;   
                        _this.setDataCategoryFetched(initialLoad, category);        
                    });
                });
            
            } else {
                category.fetch().then(function() {    
                    _this.category = category;
                    _this.realCategory = null;   
                    _this.setDataCategoryFetched(initialLoad, category);        
                });
            }

        };

        _this.setDataCategoryFetched = function(initialLoad, category) {
            var cat = _this.category;
            if(_this.realCategory){
                cat = _this.realCategory;
            }
            //ITX LEGACY
            inditex.iCategoryId = cat.id;
            inditex.iCategoryJSON = cat;
            inditex.iCategoryKey = cat.key;
            inditex.iPage = 'ItxCategoryPage';
            $('html').attr('id', 'ItxCategoryPage');
            //ITX LEGACY END
            
            _this.isCategoryPage = true;
            
            SeoService.updateMetas();

            if(initialLoad){
                CatalogUrlService.initialStateCategory(_this.category);
            }

            imDispatcherService.sortEvent('pageview', null, category);
            _this.reloadCategory = !_this.reloadCategory;
            $scope.$applyAsync();            
        }

        _this.getProduct = function(productId, colorId, set){
            var product;
            if (productId instanceof Product || productId.id) {
                inditex.iProductId = productId.id;
                if(productId.fetched ){
                    product = productId;
                }
                else{
                    product = new Product(productId, colorId, null, productId.categoryId, null, set); 
                }
              
            } else {
                
                var categoryId = inditex.iCategoryId;
                if (_this.category) {
                    categoryId = _this.categoryId;
                }
                inditex.iProductId = productId;
                product = new Product(productId, colorId, null, categoryId, null, set); 
            }
            return product;
        };


        _this.loadProduct = function(productId, colorId, initialLoad, set) {
            
            ItxLoaderFct.show();
            var imgs = $('.ma-product .lazy-img-wrapper img.main-image');
            
            imgs.each(function() {
                $(this).attr('src', window.itxApp.imgNormal);
            });
            var _this = this;
            _this.productPageLoadedOnce = false;
            _this.loadingProduct = true;
          
            var product =  _this.getProduct(productId, colorId, set);

            if(product.fetched){
                    //ITX LEGACY
                inditex.iPage = 'ItxProductPage';
                $('html').attr('id', 'ItxProductPage');
                //ITX LEGACY END
                _this.productPageLoadedOnce = true;
                ItxLoaderFct.hide();

                _this.product = product;
                
                _this.loadingProduct = false;
                
                if (!initialLoad) { 
                    SeoService.updateMetas();
                }
                _this.isCategoryPage = false;
                ItxLoaderFct.hide();
                if(initialLoad){
                    CatalogUrlService.initialStateProduct(product);
                }
            }
            else{
                product.fetch().then(function() {
                    
                    var showNoStock = inditex.xconf.SHOW_PRODUCT_CATEGORY_SKU_NO_STOCK;
                    var enabledSoldOut = (inditex.xconf.ENABLED_SOLD_OUT_410_PAGE === '1' );
  
                    if ((product.visibility === joyr.constants.visibility.HIDDEN_VISIBILITY ||
                            (product.visibility === joyr.constants.visibility.SOLD_OUT_VISIBILITY && showNoStock == 'HIDDEN')) &&
                            enabledSoldOut  && (inditex.iProductId == productId)) {
                        // redirect to 410 product page
                         _this.goToNotFoundPage(product);
                    }

                    if (!ItxProductSwiperSvc.isCompatibleBrowser()) {
                        console.error('no compatile browser');
                    }

                    inditex.iPage = 'ItxProductPage';
                    $('html').attr('id', 'ItxProductPage');

                    SeoService.updateMetas();
                    if(initialLoad){
                        CatalogUrlService.initialStateProduct(product);
                    }

                    //Iniciamos sección
                    _this.productPageLoadedOnce = true;
                    _this.isCategoryPage = false;
                    _this.product = product;
                    ItxLoaderFct.hide();
                    $scope.$apply();
                    _this.loadingProduct = false;

                    if (!_this.category) {
                        _this.loadCategoryWithProductId();
                    }

                }).Catch(function() {
                    logger.logError('errr');
                    _this.loadingProduct = false;
                });
            }          
        };

        _this.headerName = function() {
            var name = '';
            if (!_this.isCategoryPage && _this.product && _this.product.fetched) {
                name = _this.product.name;
            }
            return name;
        };

        _this.nextProduct = function() {
            _this.slideToOtherProduct(_this.product, 'next');
        };

        _this.prevProduct = function() {
            _this.slideToOtherProduct(_this.product, 'prev');
        };

        _this.back = function() {
            CatalogUrlService.back();
            return;
        };

        _this.isFirst = function() {
            if(_this.category && _this.category.visibleProducts.length && _this.product && _this.productIndex > 0) {
                if(_this.category.visibleProducts[0].id === _this.product.id) {
                    // Validamos de que el producto posea color y validamos por el mismo.
                    if(_this.category.visibleProducts[0].pendingColor !== null && _this.product.pendingColor) {
                        if(_this.category.visibleProducts[0].pendingColor === _this.product.pendingColor) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        // Validamos unicamente por id.
                        return true;
                    }
                } else {
                    return false;
                }
            }
            else{
                return true;
            }
        }

        _this.isLast = function() {
            if(_this.category && _this.category.visibleProducts.length && _this.product && _this.productIndex < _this.category.visibleProducts.length) {
                if(_this.category.visibleProducts[_this.category.visibleProducts.length - 1].id === _this.product.id) {
                    if(_this.category.visibleProducts[0].pendingColor !== null && _this.product.pendingColor) { 
                        if(_this.category.visibleProducts[_this.category.visibleProducts.length - 1].pendingColor === _this.product.pendingColor) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            }
            else{
                return true;
            }
        };

        _this.productColorChanged = function() {

            var categoryId = _this.category? _this.category.id: null;

            ProductViewedCacheSvc.addProduct(_this.product.id, _this.product.state.selectedColor.id,categoryId);

            // Manda las analíticas también a Hero
            imProductService.sendProductViewToHero(_this.product);
            
        };

        _this.setProductIndex = function(productSel) { 
            _this.productIndex = _.findIndex(_this.category.visibleProducts, function(product) {
                if(productSel.id === product.id) {
                    if(productSel.pendingColor && product.pendingColor) { 
                        return productSel.pendingColor === product.pendingColor;
                    } else {
                        return productSel.id === product.id;
                    }
                } else {
                    return productSel._uniqueId === product._uniqueId;
                }
            });

            if (_this.productIndex === -1) {
                _this.productIndex = _.findIndex(_this.category.visibleProducts, function(product) {
                    return productSel.id === product.id;
                });
            }
        };

        _this.slideToOtherProduct = function(product, type, isBanner) {
            if (_this.loadingProduct || (!_this.category || !_this.category.visibleProducts)) {
                return;
            }

            if (!_this.productIndex || isBanner) {
                _this.setProductIndex(product);
            }

            _this.productIndex = _this.setIndex(type, _this.productIndex);
            
            var product = _this.category.visibleProducts[_this.productIndex];
            
            if(product.state.isBanner || product.state.isFakeBanner){
                if(_this.productIndex != 0){
                    //_this.productIndex = _this.setIndex(type, _this.productIndex);
                    _this.slideToOtherProduct(_this.category.visibleProducts[_this.productIndex], type, true);
                } else {
                    return;
                }
            } else {
                CatalogUrlService.changeStateProduct(product);
            }
        };

        _this.setIndex = function (type, index) {
            switch (type) {
                case 'next':
                    index++;
                    break;
                case 'prev':
                    if (_this.productIndex > 0) {
                        index--;
                    }
                    break;
            }
            return index;
        };

        _this.loadCategoryWithProductId = function() {
            var categoryId = _this.product.categoryId;

            // Desde el buscador no siempre viene la categoryId, el volver debe tirar de history porque no tenemos category
            if (!categoryId || categoryId === 0) {
                return;
            }

            new Category({ 
                id: categoryId
            }).fetch().then(function(category) {
                _this.category = category;
                $scope.$apply();
            });
        };

        _this.goToNotFoundPage = function(product){
            window.location = inditex.encodeUrl({
                'action': 'Itx410ErrorPage',
                'params': {
                    'storeId': inditex.iStoreId,
                    'langId': inditex.iLangId,
                    'catalogId': inditex.iCatalogId,
                    'categoryId': inditex.iCategoryId || 0,
                    'productId': product.id
                }
            });
        }

    }

})();